/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum AccountingImportStatus {
    UPLOADED = 'uploaded',
    IN_PROGRESS = 'in_progress',
    AI_PREDICTION_IN_PROGRESS = 'ai_prediction_in_progress',
    DONE = 'done',
    ERROR = 'error',
}
